export default function () {
  return function (chatbot) {
    window.openChatbot = function () {
      chatbot.actions.showConversationWindow();
    };
  };
}
